$(document).ready(function(){

jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

$('.atservice-slider').slick({
  arrows: true,
  dots: false,
  infinite: true,
   autoplay: true,
   autoplaySpeed: 7000,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  
});